export type SupportedLanguage = 'en' | 'de' | 'es' | 'fr' | 'it' | 'pt' | 'nl' | 'pl' | 'zh' | 'ja';

export const LANGUAGES: { code: SupportedLanguage; name: string; flag: string; nativeName: string }[] = [
  { code: 'en', name: 'English', flag: '🇬🇧', nativeName: 'English' },
  { code: 'de', name: 'German', flag: '🇩🇪', nativeName: 'Deutsch' },
  { code: 'es', name: 'Spanish', flag: '🇪🇸', nativeName: 'Español' },
  { code: 'fr', name: 'French', flag: '🇫🇷', nativeName: 'Français' },
  { code: 'it', name: 'Italian', flag: '🇮🇹', nativeName: 'Italiano' },
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹', nativeName: 'Português' },
  { code: 'nl', name: 'Dutch', flag: '🇳🇱', nativeName: 'Nederlands' },
  { code: 'pl', name: 'Polish', flag: '🇵🇱', nativeName: 'Polski' },
  { code: 'zh', name: 'Chinese', flag: '🇨🇳', nativeName: '中文' },
  { code: 'ja', name: 'Japanese', flag: '🇯🇵', nativeName: '日本語' }
];

export const getLanguageName = (code?: SupportedLanguage): string => {
  const language = LANGUAGES.find(l => l.code === code);
  return language ? language.name : 'English';
};

export const getLanguageFlag = (code?: SupportedLanguage): string => {
  const language = LANGUAGES.find(l => l.code === code);
  return language ? language.flag : '🇬🇧';
};

export const getLanguageNativeName = (code?: SupportedLanguage): string => {
  const language = LANGUAGES.find(l => l.code === code);
  return language ? language.nativeName : 'English';
};

export const getLanguageForAI = (code?: SupportedLanguage): string => {
  const mapping: Record<SupportedLanguage, string> = {
    'en': 'English',
    'de': 'German (Deutsch)',
    'es': 'Spanish (Español)',
    'fr': 'French (Français)',
    'it': 'Italian (Italiano)',
    'pt': 'Portuguese (Português)',
    'nl': 'Dutch (Nederlands)',
    'pl': 'Polish (Polski)',
    'zh': 'Chinese (中文)',
    'ja': 'Japanese (日本語)'
  };
  return mapping[code || 'en'] || 'English';
};

